<div class="content">
    <div class="explorer">
        <div class="explorer-header">book.name</div>
        <ul class="file-tree">
            <li>
                <div class="folder">
                    <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="m9 18 6-6-6-6" />
                    </svg>
                    <svg class="icon folder-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-6l-2-2H5a2 2 0 0 0-2 2Z" />
                    </svg>
                    <span class="folder-name">Images</span>
                </div>
                <ul class="folder-content">
                    <li *ngFor="let img of images" [ngClass]="currentFile == img?'active':''" (click)="contentChange(img,'image')">
                        <div class="file">
                            <span style="width: 16px"></span>
                            <svg class="icon file-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                            </svg>
                            <span class="file-name">{{img.split('_')[1]}}</span>
                        </div>
                    </li>
                </ul>
            </li>
            <li>
                <div class="folder">
                    <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="m9 18 6-6-6-6" />
                    </svg>
                    <svg class="icon folder-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-6l-2-2H5a2 2 0 0 0-2 2Z" />
                    </svg>
                    <span class="folder-name">Files</span>
                </div>
                <ul class="folder-content">
                    <li *ngFor="let file of files" [ngClass]="currentFile == file?'active':''" (click)="contentChange(file,'file')">
                        <div class="file">
                            <span style="width: 16px"></span>
                            <svg class="icon file-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                            </svg>
                            <span class="file-name">{{file.split('_')[1]}}</span>
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
    <div class="editor">
        <pre class="code-content">// {{currentFile.split('_')[1]}}</pre>

        <div *ngIf="currentFileType == 'image'" style="text-align: center;">
            <img [src]="siteUrl+'api/static'+currentFile"/>
        </div>

        <div *ngIf="currentFileType == 'file'" style="text-align: center;">
            <ngx-doc-viewer [url]="siteUrl+'api/static'+currentFile"  style="width:100%;height:80vh;"></ngx-doc-viewer>
            
        </div>
    </div>
</div>